interface CategoryAward {
  status?: string;
  category?: { name?: string; icon?: string | null } | null;
}

interface Award extends CategoryAward {
  year: number;
  status?: string;
  category?: { name?: string } | null;
  category_award?: CategoryAward | null;
  jury_prizes?: { name: string }[];
}

// Undefined means an older API response; explicit null means no category award.
export function bestOfCategoryAward(
  award: Award | null | undefined
): CategoryAward | null | undefined {
  return award?.category_award === undefined ? award : award.category_award;
}

export function bestOfAwardLabel(award: Award): string {
  if (award.category_award !== undefined) {
    const category = bestOfCategoryAward(award);
    if (!category) return `Best of ${award.year}`;
    return bestOfAwardLabel({ year: award.year, ...category });
  }
  const status =
    {
      winner: 'Winner',
      honoree: 'Honoree',
      draft: 'Draft',
      submitted: 'Submission',
      withdrawn: 'Withdrawn submission',
    }[award.status] || '';
  return (
    [`Best of ${award.year}`, status].filter(Boolean).join(' ') +
    (award.category?.name ? ` — ${award.category.name}` : '')
  );
}
